import React from 'react';
import { observer } from "mobx-react";
import { translateText, accessibilityStatement, getDirection, getFirstSide, getLastSide } from "../../stores/objects/I18n";
import {Collapse, Card, Button, Modal} from 'antd'
import { RightOutlined, LeftOutlined, DownOutlined } from '@ant-design/icons';
const { Panel } = Collapse;




const AccessibilityView = observer(({store}) => {

    let content = (
    <span>
    <Collapse
        expandIconPosition={getFirstSide(store)}
         expandIcon={({ isActive }) => 
            (isActive ? <DownOutlined /> : (getLastSide(store) === 'rtl' ? <LeftOutlined /> : <RightOutlined />))}>
         <Panel key="Accessibility statement" 
                header={translateText(store, "Accessibility Statement")} >
                     <span>{accessibilityStatement(store)}</span>
         </Panel>
     </Collapse>
     <Card bordered={false} 
           style={{direction: getDirection(store)}}>
           {translateText(store, "Do you want to " +
                                 (store.state.accessibilityEnabled ? "deactivate" : "activate")
                                 +  " accessibility mode?")}
     </Card>
     </span>
    );

    
    return  (
    <Modal 
    visible={store.state.accessibilityDeclerationOpen}
    title={translateText(store, "Accessibility")}
    okText={translateText(store, "OK")}
    cancelText={translateText(store, "Cancel")}                   
    onCancel={() =>  {store.state.accessibilityDeclerationOpen = false;}}
    onOk={store.toggleAccessibility}
    className={"CSUS-SE-"+getDirection(store)+" CSUS-SE-accessible"}>
        {content}
    </Modal>
    );
});

const AccessibilityPicker = observer(({store, inputRef}) => {
    
    let ref = store.state.searchExists ? inputRef : inputRef;
    let text = store.state.searchExists ? translateText(store, "Go to results view") : translateText(store, "Go to new search")
    let toplink = (!store.state.accessibilityEnabled) ? "" : 
                        (<Button className="CSUS-SE-lang-picker-btn CSUS-SE-btn"
                                 tabindex="1"
                                 key="mainViewlink"
                                 type="link"
                                 style={{width: "86px"}}
                                 aria-label="Accessibility mode" 
                                 onClick={() => ref.current.focus()}> 
                                 {text}
                        </Button>);

    return (
    <span className="CSUS-SE-accessible">
        {toplink}
    <Button onClick={() => {store.state.accessibilityDeclerationOpen = true;}}
    className="CSUS-SE-btn"
    tabIndex="2">
    <span className="fab fa-accessible-icon"/>
    </Button>
    </span>
)});

export {AccessibilityPicker, AccessibilityView}